
export default{
    // @BusinessContract
    newCreatedBusinessContract: {},
    newCreatedDriverContract: {}
}